import classNames from 'clsx';
import React from 'react';
import ArticleCard from './ArticleCard';

export default function ArticleList({
  posts,
  variant = 'default',
  className = '',
}) {
  return (
    <div
      className={classNames(className, {
        'grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-3 lg:gap-x-9 lg:gap-y-32':
          variant !== 'side',
        'grid grid-cols-12 gap-2 md:gap-12 lg:gap-2 lg:gap-y-10':
          variant === 'side',
      })}>
      {posts &&
        posts.map((item, i) => (
          <ArticleCard
            key={i}
            data={item}
            showCategory={false}
            className={classNames(
              {
                'sm:col-span-2 lg:col-span-3':
                  i === 0 && variant === 'featured',
              },
              {
                'col-span-12 lg:col-span-7 lg:row-span-2':
                  i === 0 && variant === 'side',
              },
              {
                'col-span-12 md:col-span-6 lg:col-span-4 lg:col-start-9':
                  i !== 0 && variant === 'side',
              },
            )}
            variant={variant === 'featured' ? 'default' : variant}
          />
        ))}
    </div>
  );
}
